import { CustomMetric, CustomDetail, jsonSafeToCustomMetric, jsonSafeToCustomDetail } from "./db";
import { SelectColumn, BackendFilter } from "./sessions";


export type MetricDetailResultV6 = (string | number | null)[][]

export type TableAggColumn = {
  column: SelectColumn
  column_type: 'TABLE'
}

export type CNFAggColumn = {
  cnf: BackendFilter
  column_type: 'CNF'
}

export type AggColumn = TableAggColumn | CNFAggColumn

export type AggGroupBy = {
  column: SelectColumn
  step_size_safe?: number
  step_start_safe?: number
  step_modulus_safe?: number
}

export type MetricSelectV6 = {
  selects: AggColumn[]
  cnf: BackendFilter
  group_by: AggGroupBy | null
}

export type MetricDetailParamsV6 = MetricSelectV6 & {
  start: Date
  end: Date
}////////////////////////////////////////////
// AreaCodeConnectRateResult is the return type of `area-code-connect-rate`
////////////////////////////////////////////

export type AreaCodeConnectRateResult = {
  'area_code': string | null
  'call_count': number
  'connect_rate': number
}

export type MetricResult = {
  metric: CustomMetric
  detail: CustomDetail
}

export type ReviewCount = {
  name: string
  count: number
}

export function jsonSafeToReviewCount(value: any[]): ReviewCount {
  return {
    name: value[0],
    count: value[1]
  }
}

export function jsonSafeToReviewCounts(value: any[]): ReviewCount[] {
  return value.map((v: any[]) => jsonSafeToReviewCount(v))
}

